import {
  type ChildAgePickerComponentProps as CoreChildAgePickerComponentProps,
  useChildAgePicker,
} from "@b2bportal/core-hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Select, SelectItem } from "@tenant/ui";
import clsx from "clsx";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types";
import defaultStyles from "./styles.module.scss";

export type ChildAgePickerComponentProps = CoreChildAgePickerComponentProps & {
  id?: string | number;
};

export const ChildAgePicker = (props: ChildAgePickerComponentProps) => {
  const { t } = useI18nContext();
  const { context, handlers } = useChildAgePicker(props);

  const styles = useApacHotelsStyles(
    ApacHotelsComponent.ChildAgePicker,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, ApacHotelsComponent.ChildAgePicker);
  const placeholder = t("guestCount.childrenAgePlaceholder", {
    index: props?.id,
  });

  return (
    <div className={clsx(block, props.className)}>
      <Select
        className={cn("select")}
        options={context.ageOptions}
        value={context.childAgeString}
        onValueChange={(value) => {
          handlers.onAgeSelectHandler(Number(value));
        }}
        placeholder={placeholder}
      >
        {context.ageOptions.map((item, index) => {
          return (
            <SelectItem
              key={item.key || `${item.value}-${index}`}
              value={item.value}
            >
              <span className={cn("item")}>{item.label}</span>
            </SelectItem>
          );
        })}
      </Select>
    </div>
  );
};
